import { render } from "./search.vue?vue&type=template&id=f52e8656&scoped=true"
import script from "./search.vue?vue&type=script&lang=js"
export * from "./search.vue?vue&type=script&lang=js"

import "./search.vue?vue&type=style&index=0&id=f52e8656&lang=scss&scoped=true"
import "./search.vue?vue&type=style&index=1&id=f52e8656&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f52e8656"]])

export default __exports__